import React, {useMemo} from 'react';
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import Hexa from './hexa'; // 引入你的 hexa.tsx
import QueryState from '@/component/QueryState'
import {BUILD_STATE, BuildStateType} from "@/utils/constants";

const App: React.FC = () => {

    return (
        <Router>
            <Routes>
                <Route path="/" element={
                    BUILD_STATE === BuildStateType.UNIHEXA
                        ? <Hexa/>
                        : <div className="page-main">
                            <div className="app-header-bg"></div>
                            <QueryState/>
                        </div>
                }/>
            </Routes>
        </Router>
    );
};

export default App;
